<template>
  <div>
    
    <!-- Header Wrapper -->
    <Header></Header>
    <!-- Main Content -->
    <div style="top: 70px; position: relative; min-height: 100vh;">
      <router-view></router-view>
    </div>
   
    <!-- Footer-->
    <Footer></Footer>
    
      
  </div>
</template>

<script>

export default {
  data () {
    return {
      title_name: "Raizzon Infotech LLP"
    }
  },
  computed: {
    getCurrentRoutePath() {
      return this.$router.currentRoute.path
    },
    getCurrentRoute() {
      return this.$router.currentRoute
    },
    getCanonicalURL() {
      return 'https://'+window.location.hostname+''+this.getCurrentRoutePath
    }
  },
  components: {
    
  },
  methods: {
      changeRoute(to) {
        document.title = to.meta.title
        document.getElementById("keywords").setAttribute('content',to.meta.keywords)
          
        document.getElementById("desc").setAttribute('content',to.meta.description)
        document.getElementById("canonical").setAttribute('href',this.getCanonicalURL)
      }
  },
  created() {
    setTimeout(() => {
      this.changeRoute(this.$route)    
    }, 1000);    
  },
  mounted() {
    window.scrollTo(0,0)
  },
  watch: {
      '$route' (to) {
        window.scrollTo(0,0)
        this.changeRoute(to)
      }
  }
}
</script>

<style>

body {
  font-family: 'Roboto', sans-serif;
  font-size: 13px;
  color: #5e5454;
  line-height: 20px;
  letter-spacing: 1px;
  overflow-x: hidden !important;
}

.flexSpaceBetween {
  display: flex; 
  flex-direction: row; 
  justify-content: space-between; 
}

.heading {
  font-size: 34px;
  line-height: 42px;

}
</style>



// WEBPACK FOOTER //
// src/App.vue